import { Component, OnInit, Renderer2, ChangeDetectorRef, AfterViewInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "[app-name-text]",
  templateUrl: "./name-text.component.html",
  styleUrls: ["./name-text.component.scss"]
})
export class NameTextComponent implements OnInit, AfterViewInit {
  @Input() name: string;
  @Input() svgNameCords: number[];
  @Input() svgNameMaxWidth: string;
  @Input() extraClass: string;

  @ViewChild("textLineContainer") svgTextLineContainer: ElementRef;

  svgTSpan: string[] = [];
  translatedName: string = null;

  constructor(
    private renderer: Renderer2,
    private translate: TranslateService,
    private changeDetection: ChangeDetectorRef
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.translate.get(this.name).subscribe((res: string) => {
      this.translatedName = res;
      this.initSvgNameLineBreak();
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.svgTSpan = [];
    this.initSvgNameLineBreak();
  }

  private getElementData(element: any) {
    return {
      cx: parseFloat(element.getAttributeNS(null, "cx")),
      cy: parseFloat(element.getAttributeNS(null, "cy")),
      r: parseFloat(element.getAttributeNS(null, "r")),
      clientRect: element.getBoundingClientRect()
    };
  }

  initSvgNameLineBreak() {
    const splittedName = this.translatedName.split(" ");
    let part: string,
      currentText: string = "",
      svgTextElData: any,
      lastIdxAnalized: number;
    for (let i = 0; i < splittedName.length; i++) {
      let part = splittedName[i];
      this.renderer.setProperty(
        this.svgTextLineContainer.nativeElement,
        "textContent",
        (currentText + " " + part).trim()
      );
      svgTextElData = this.getElementData(
        this.svgTextLineContainer.nativeElement
      );
      if (
        svgTextElData.clientRect.width > this.svgNameMaxWidth &&
        lastIdxAnalized != i
      ) {
        if (currentText != "") {
          this.svgTSpan.push(currentText.trim());
          this.renderer.setProperty(
            this.svgTextLineContainer.nativeElement,
            "textContent",
            ""
          );
        }
        lastIdxAnalized = i;
        i--;
        currentText = "";
      } else if ([lastIdxAnalized, splittedName.length - 1].indexOf(i) !== -1) {
        this.svgTSpan.push((currentText + " " + part).trim());
      } else {
        currentText += " " + part;
        currentText = currentText.trim();
      }
    }
    this.renderer.setProperty(
      this.svgTextLineContainer.nativeElement,
      "textContent",
      ""
    );
    this.changeDetection.detectChanges();
  }
}
